import React, { useState } from "react";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(text.length > 100);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text.slice(0, 100) : text}
      {text.length > 100 && (
        <span
          onClick={toggleReadMore}
          className="read-or-hide"
          style={{
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {isReadMore ? "...read more" : " show less"}
        </span>
      )}
    </p>
  );
};
export { ReadMore };
